<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CuI8WO/tc-custom/9780814341735.jpg?1724210562927" alt="This image is the cover for the book Fairy Tale Review"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fairy Tale Review
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>The fourth issue of <i>Fairy Tale Review</i>, The White Issue features original fiction and poetry with fairy tale aesthetics.</b> </p><p>"All great novels are great fairy tales," wrote Vladimir Nabokov many years ago, and <i>Fairy Tale Review</i> continues to believe that all great literary works owe everything to fairy tales. In this issue you will find work represented that draws from the spectacular, old tradition of fairy tales in brilliant new ways. An increased understanding of the precise and incredible fairy-tale techniques, so wonderfully elucidated by the scholar Max Luthi, but expanded, in the aesthetic of <i>Fairy Tale Review</i>, to contemporary literature across the styles and genres, may help resolve the unfortunate schisms that sometimes arise between so-called mainstream and avant-garde writers and critics. In this issue you will find work across so many such borders; some of the writing refers to specific fairy tales, but much of it simply feels like a fairy tale; and how it feels like a fairy tale is through language, through form. Please spread the word that fairy tales are the newest and oldest aesthetic; and they give our lives fearful, beautiful shape. Form is fairy tale, fairy tale is form.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Bernheimer
      </h2>
      
      <p class="authorDescription body article"><p>Kate Bernheimer has been called "one of the living masters of the fairy tale" (Tin House). She is the author of a novel trilogy and the story collections <i>Horse, Flower, Bird</i> and <i>How a Mother Weaned Her Girl from Fairy Tales</i>, and the editor of four anthologies, including the World Fantasy Award winning and bestselling <i>My Mother She Killed Me, My Father He Ate Me: Forty New Fairy Tales</i>and <i>xo Orpheus: 50 New Myths</i>. She is an Associate Professor of English at the University of Arizona in Tucson, where she teaches fairy tales and creative writing.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bec10974